import React, { useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Link, useNavigate, NavLink } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import "./Login.css";
import { useMediaQuery, useTheme } from "@mui/material";
// import lightlogo from "../../Img/reglogo.png";
// import loginprofilepic from "../../Img/login-icon.svg";
// import lgleft from '../../Img/lgleft.png';
// import signin from "../../Img/ph-img-signin.svg";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import FormControl from "@mui/material/FormControl";
// import TextField from '@mui/material/TextField';
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
// import Button from '@mui/material/Button';
// import Typography from '@mui/material/Typography';
import Modal from "@mui/material/Modal";
// import usercalls from "../../Axios";
// import consts from "../../constant";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import LoginBtn from "./LoginBtn";
// import AuthHeader from "./AuthHeader";
import AuthLeft from "./AuthLeft";
import Success from "../../Images/tick-img.svg";
import { useLocation } from "react-router-dom";
import { useRef } from "react";
import { SendOtp, VerifyOtp } from "../../services/auth";
// import Loader from "../Loader";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "#fff",
  // border: '2px solid #000',
  boxShadow: 24,
  borderRadius: "10px",
  outline: "none",
  "@media(max-width:767.98px)": {
    width: "75%",
  },
  p: 4,
};

export default function AccountVerify() {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));
  //   const path = usercalls();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [load, setLoad] = useState(false);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const location = useLocation();

  const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[0-9]).{8,}$/;
  const regex = /[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}(.[a-z{2,8}])?/g;

  const navigate = useNavigate();

  const [otp, setOtp] = useState(Array(6).fill("")); // Array with 6 empty strings
  const inputRefs = useRef([]);

  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

  const handleClickConfirmShowPassword = () =>
    setShowConfirmPassword((show) => !show);

  const [confPassErr, setConfPassErr] = useState("");

  const checkconfirmpass = (e) => {
    if (password != e) {
      setConfPassErr("Password Mismatching");
    } else {
      setConfPassErr("");
    }
  };

  const [verify, setVerify] = useState(false);
  const [forgot, setForgot] = useState(false);
  // const[email,setEmail]=useState();
  const [enableOtp, setEnableOtp] = useState(false);

  useEffect(() => {
    // const verifyStatus = location?.state?.verify;
    // const forgotStatus = location?.state?.forgot;
    // setVerify(verifyStatus);
    // setForgot(forgotStatus);
    if (location?.state?.email) {
      setEmail(location?.state?.email);
      setEnableOtp(true);
    }
  }, []);

  const handleInput = (e) => {
    const { target } = e;
    const index = inputRefs.current.indexOf(target);

    if (target.value) {
      setOtp((prevOtp) => [
        ...prevOtp.slice(0, index),
        target.value,
        ...prevOtp.slice(index + 1),
      ]);

      // Move focus to the next input field
      if (index < otp.length - 1) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e) => {
    const index = inputRefs.current.indexOf(e.target);

    // Allow only numeric input or Backspace/Delete/Tab
    if (
      !/^[0-9]{1}$/.test(e.key) &&
      e.key !== "Backspace" &&
      e.key !== "Delete" &&
      e.key !== "Tab" &&
      !e.metaKey
    ) {
      e.preventDefault();
    }

    // Handle Backspace/Delete key
    if (e.key === "Backspace" || e.key === "Delete") {
      if (otp[index] !== "") {
        // If the current input has a value, clear it
        setOtp((prevOtp) => {
          const updatedOtp = [...prevOtp];
          updatedOtp[index] = "";
          return updatedOtp;
        });
      } else if (index > 0) {
        // If the current input is empty, move focus to the previous input field
        setOtp((prevOtp) => {
          const updatedOtp = [...prevOtp];
          updatedOtp[index - 1] = ""; // Clear the previous input
          return updatedOtp;
        });
        inputRefs.current[index - 1].focus(); // Move focus to the previous field
      }
    }
  };
  const handlePaste = (e) => {
    e.preventDefault();  // Prevent the default paste action
  
    const text = e?.clipboardData?.getData("text"); // Get the pasted text from clipboard
  
    // Ensure the pasted text matches the OTP length and contains only digits
    if (!/^\d{6}$/.test(text)) {
      return; // If the pasted text isn't 6 digits, prevent pasting
    }
  
    // Split the pasted text into individual digits and update the OTP state
    const digits = text.split(""); // Convert the string to an array of digits
  
    setOtp(digits); // Update the OTP state with the new digits
  
    // Move focus to the next input after pasting (optional, if necessary)
    inputRefs.current[digits.length - 1].focus();
  };

  const handleFocus = (e) => {
    e.target.select();
  };

  useEffect(() => {
    if (window.localStorage.getItem("email")) {
      setEmail(localStorage.getItem("email"));
      localStorage.removeItem("email");
    }
  }, []);
  const handleSubmit = async (e) => {
    // e.preventDefault();
    setLoad(true);
    const otpString = otp?.join("");

    const data = {
      email: email,
      OTP: otpString,
    };
    setLoad(true);
    const response = await VerifyOtp(data);
    if (response?.data?.success === true) {
 
      toast.success(response.data.message);
      setTimeout(() => {
        navigate("/login");
      }, 1000);
      setLoad(false);
    } else {
      toast.error(response?.data?.message);
      setLoad(false);
    }
  };

  const [allUsers, setAllUsers] = useState({});
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setAllUsers({ ...allUsers, [name]: value });
  };
  const validateFocus = (e) => {
    const fieldName = e?.target?.name;
    const fieldValue = e?.target?.value;
    const value = fieldValue.trim();

    let isValid = true;
    let errorMessage = "";

    // Handle email validation
    if (fieldName === "email") {
      if (value === "" || value === undefined) {
        // errorMessage = "Email is required";
        // isValid = false;
      } else if (!/\S+@\S+\.\S+/.test(fieldValue)) {
        errorMessage = "Email is invalid";
        isValid = false;
      }
    }

    // Set errors after validation
    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: errorMessage,
    }));

    return isValid;
  };

  const validate = () => {
    let formErrors = {};
    let isValid = true;

    // Validate email
    if (!allUsers.email) {
      formErrors.email = "Email is required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(allUsers.email)) {
      formErrors.email = "Email is invalid";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  };

  const handleForgotSubmit = async (e) => {
    const data = {
      type: "email",
      email: allUsers.email,
    };
    e.preventDefault();
    if (validate()) {
      setLoad(true);

      const response = await SendOtp(data);

      if (response?.data?.success === true) {
        setLoad(false);
        toast.success(response?.data?.message);
        setEnableOtp(true);
        // setTimeout(() => {
        //   navigate("/success", {
        //     state: { forgot: true, email: allUsers.email },
        //   });
        // }, 1500);
      } else {
        toast.error(response?.data?.message);
        setLoad(false);
      }
    }
  };
  return (
    <>
      {/* <AuthHeader /> */}
      {/* <Loader/> */}
      <ToastContainer  
            autoClose={2000}
          />
      <div className="register">
        <Grid
          container
          component="main"
          spacing={2}
          sx={{ alignItems: "center", pt: 0 }}
          className={!md ? "medium" : ""}
        >
          <Grid
            size={{ xs: 12, sm: 12, md: 12, lg: 6 }}
            sx={{ pt: 0 }}
            style={{ paddingTop: "0px" }}
          >
            <AuthLeft />
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
            <Grid
              container
              sx={{ justifyContent: "center", alignItems: "center" }}
            >
              {enableOtp === false ? (
                <div>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Box
                      sx={{
                        my: md && 3,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        // padding: "28px 25px",
                      }}
                      // className={!md && "log-bcg"}
                    >
                      <h2 className="c-accout">Send Email</h2>

                      <Box sx={{ mt: 1, width: "100%" }}>
                        <div className="input-common">
                          <label>Email</label>
                          <TextField
                            fullWidth
                            id="fullWidth"
                            placeholder="Email"
                            name="email"
                            onChange={(e) => handleChange(e)}
                            value={allUsers.email}
                            onFocus={(e) => validateFocus(e)}
                            onInput={validateFocus}
                            error={!!errors.email}
                            helperText={errors.email}
                            required
                          />
                        </div>
                      </Box>
                    </Box>
                  </Grid>

                  <div className="common-btn text-center">
                    {load ? (
                      <Button fullWidth sx={{ mt: 3, mb: 2 }}>
                        Processing...
                      </Button>
                    ) : (
                      <Button
                        type="submit"
                        fullWidth
                        sx={{ mt: 3, mb: 2 }}
                        onClick={handleForgotSubmit}
                        // onClick={() => {
                        //   navigate("/trade");
                        // }}
                      >
                        Send Otp
                      </Button>
                    )}
                  </div>
                </div>
              ) : (
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Box
                    sx={{
                      my: md && 3,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      // padding: "28px 25px",
                    }}
                    // className={!md && "log-bcg"}
                  >
                    <h2 className="c-accout">OTP Verification</h2>

                    <Box sx={{ mt: 1, width: "100%" }}>
                      {/* <div className="common-btn text-center">
                  {load ? (
                    <Button fullWidth sx={{ mt: 3, mb: 2 }}>
                      Processing...
                    </Button>
                  ) : (
                    <Button
                      type="submit"
                      fullWidth
                      sx={{ mt: 3, mb: 2 }}
                      onClick={() => {
                        navigate("/login");
                      }}
                    >
                      Login
                    </Button>
                  )}
                </div> */}

                      <Box sx={{ mt: 4, width: "100%" }}>
                        <Grid container spacing={2}>
                          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                            <div className="input-common otp-input mt-20 mb-20">
                              {/* <label>Email</label> */}
                              <form id="otp-form" className="otp-input-form">
                                {otp.map((digit, index) => (
                                  <input
                                    key={index}
                                    type="text"
                                    maxLength={1}
                                    value={digit}
                                    onChange={handleInput}
                                    onKeyDown={handleKeyDown}
                                    onFocus={handleFocus}
                                    onPaste={handlePaste}
                                    ref={(el) =>
                                      (inputRefs.current[index] = el)
                                    }
                                    className="shadow-xs flex w-[64px] items-center justify-center rounded-lg border border-stroke bg-white p-2 text-center text-2xl font-medium text-gray-5 outline-none sm:text-4xl dark:border-dark-3 dark:bg-white/5"
                                  />
                                ))}
                                {/* You can conditionally render a submit button here based on otp length */}
                              </form>
                            </div>
                          </Grid>
                        </Grid>

                        <div className="common-btn text-center">
                          {load ? (
                            <Button fullWidth sx={{ mt: 3, mb: 2 }}>
                              Processing...
                            </Button>
                          ) : (
                            <Button
                              type="submit"
                              fullWidth
                              sx={{ mt: 3, mb: 2 }}
                              onClick={handleSubmit}
                              // onClick={() => {
                              //   navigate("/trade");
                              // }}
                            >
                              Verify
                            </Button>
                          )}
                        </div>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              )}
            </Grid>
          </Grid>
          {/* <Modal
            open={open}
            // onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <div className="text-right">
                <HighlightOffIcon onClick={handleClose} />
              </div>
              <div className="c-accout text-center">
                Registered Successfully
              </div>
              <div className="alraedy mt-20">
                Thankyou for registering with us.
              </div>
              <div className="alraedy mt-10">Kindly Verify your email</div>

              <div className="regbtn mt-10">
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                  onClick={() => {
                    navigate("/verify");
                  }}
                >
                  Verify
                </Button>
              </div>
            </Box>
          </Modal> */}
        </Grid>
      </div>
    </>
  );
}
